export const DOWNLOAD_IMPORTED_FILE_REQUEST = 'DOWNLOAD_IMPORTED_FILE_REQUEST';
export const DOWNLOAD_IMPORTED_FILE_SUCCESS = 'DOWNLOAD_IMPORTED_FILE_SUCCESS';
export const DOWNLOAD_IMPORTED_FILE_FAILURE = 'DOWNLOAD_IMPORTED_FILE_FAILURE';
export const FETCH_FILE_IMPORT_DETAILS_REQUEST = 'FETCH_FILE_IMPORT_DETAILS_REQUEST';
export const FETCH_FILE_IMPORT_DETAILS_SUCCESS = 'FETCH_FILE_IMPORT_DETAILS_SUCCESS';
export const FETCH_FILE_IMPORT_DETAILS_FAILURE = 'FETCH_FILE_IMPORT_DETAILS_FAILURE';
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const GET_USER_BY_ID_REQUEST = 'GET_USER_BY_ID_REQUEST';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_FAILURE = 'GET_USER_BY_ID_FAILURE';

export const SAVE_USER_REQUEST = 'SAVE_USER_REQUEST';
export const SAVE_USER_SUCCESS = 'SAVE_USER_SUCCESS';
export const SAVE_USER_FAILURE = 'SAVE_USER_FAILURE';

export const EXPORT_USER_REQUEST = 'EXPORT_USER_REQUEST';
export const EXPORT_USER_SUCCESS = 'EXPORT_USER_SUCESS';
export const EXPORT_USER_FAILURE = 'EXPORT_USER_FAILURE';
export const CLEAR_USER_EXPORT = 'CLEAR_USER_EXPORT';
export const CLEAR_IMPORT_USER_RESPONSE = 'CLEAR IMPORT USER RESPONSE';

export const IMPORT_USER_REQUEST = 'IMPORT_USER_REQUEST';
export const IMPORT_USER_SUCCESS = 'IMPORT_USER_SUCESS';
export const IMPORT_USER_FAILURE = 'IMPORT_USER_FAILURE';

export const RESET_MFA_REQUEST = 'RESET_MFA_REQUEST';
export const RESET_MFA_SUCCESS = 'RESET_MFA_SUCCESS';
export const RESET_MFA_FAILURE = 'RESET_MFA_FAILURE';

export const RESEND_WELCOME_EMAIL_REQUEST = 'RESEND_WELCOME_EMAIL_REQUEST';
export const RESEND_WELCOME_EMAIL_SUCCESS = 'RESEND_WELCOME_EMAIL_SUCCESS';
export const RESEND_WELCOME_EMAIL_FAILURE = 'RESEND_WELCOME_EMAIL_FAILURE';

export const SEND_PENDING_WELCOME_EMAILS_REQUEST = 'SEND_PENDING_WELCOME_EMAILS_REQUEST';
export const SEND_PENDING_WELCOME_EMAILS_SUCCESS = 'SEND_PENDING_WELCOME_EMAILS_SUCCESS';
export const SEND_PENDING_WELCOME_EMAILS_FAILURE = 'SEND_PENDING_WELCOME_EMAILS_FAILURE';


export const GET_USER_ACTIVITY_REQUEST = 'GET_USER_ACTIVITY_REQUEST';
export const GET_USER_ACTIVITY_SUCCESS = 'GET_USER_ACTIVITY_SUCCESS';
export const GET_USER_ACTIVITY_FAILURE = 'GET_USER_ACTIVITY_FAILURE';

export const EXPORT_USER_ACTIVITY_REQUEST = 'EXPORT_USER_ACTIVITY_REQUEST';
export const EXPORT_USER_ACTIVITY_SUCCESS = 'EXPORT_USER_ACTIVITY_SUCCESS';
export const EXPORT_USER_ACTIVITY_FAILURE = 'EXPORT_USER_ACTIVITY_FAILURE';

export const GET_USER_AUTHORIZED_MAPPING_REQUEST = 'GET_USER_AUTHORIZED_MAPPING_REQUEST';
export const GET_USER_AUTHORIZED_MAPPING_SUCCESS = 'GET_USER_AUTHORIZED_MAPPING_SUCCESS';
export const GET_USER_AUTHORIZED_MAPPING_FAILURE = 'GET_USER_AUTHORIZED_MAPPING_FAILURE';

export const TOGGLE_USER_AUTHORIZED_MAPPING_REQUEST = 'TOGGLE_USER_AUTHORIZED_MAPPING_REQUEST';
export const TOGGLE_USER_AUTHORIZED_MAPPING_SUCCESS = 'TOGGLE_USER_AUTHORIZED_MAPPING_SUCCESS';
export const TOGGLE_USER_AUTHORIZED_MAPPING_FAILURE = 'TOGGLE_USER_AUTHORIZED_MAPPING_FAILURE';